import { Observer } from 'mobx-react-lite';
import type { JSX } from 'react';
import React from 'react';

import type { BaseCampaign } from '@feathr/blackbox';
import type { IColumn } from '@feathr/components';
import { TableColumnHeader } from '@feathr/components';

import * as tableStyles from '@feathr/components/dist/Table/Table.css';

const EmailDeliveriesColumn: IColumn<BaseCampaign> = {
  id: 'stats__flavors__pinpoint_tracked_email_delivered',
  checkboxLabel: 'Deliveries',
  Header: TableColumnHeader({
    title: 'Deliveries',
  }),
  width: 110,
  sortable: false,
  className: tableStyles.cellRight,
  Cell({ original }): JSX.Element {
    return (
      <Observer>
        {(): JSX.Element => {
          const stats = original.get('stats_cache');
          const flavors = stats?.flavors || {};
          const delivered = flavors.pinpoint_tracked_email_delivered || 0;
          return <>{delivered.toLocaleString()}</>;
        }}
      </Observer>
    );
  },
  Footer({ data }): JSX.Element {
    return (
      <Observer>
        {(): JSX.Element => {
          const total = data.reduce((subtotal, currentValue) => {
            const stats = currentValue._original.get('stats_cache');
            const flavors = stats?.flavors || {};
            const delivered = flavors.pinpoint_tracked_email_delivered || 0;
            return subtotal + delivered;
          }, 0);
          return <>{total.toLocaleString()}</>;
        }}
      </Observer>
    );
  },
};

export default EmailDeliveriesColumn;
